import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MUTED, NAVY, summaryTabs } from "../constants";

export function TabsNav({ activeTab, onChange }) {
  return (
    <section className="mt-5 flex gap-1 rounded-2xl bg-white border border-[#d9e1ee] p-1.5 shadow-sm">
      {summaryTabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={`flex-1 inline-flex items-center justify-center gap-2 rounded-xl px-3 py-2.5 text-xs font-black uppercase tracking-wide transition-all ${
              isActive ? "" : "hover:bg-[#f7f9fc]"
            }`}
            style={
              isActive
                ? { background: NAVY, color: "#fff", boxShadow: "0 1px 4px #0002" }
                : { color: MUTED }
            }
          >
            <FontAwesomeIcon icon={tab.icon} className="text-[10px]" />
            {tab.label}
          </button>
        );
      })}
    </section>
  );
}
